/** 실기 응원 배경. 장식은 스킨 토글에 묶고 본문·CTA 뒤에만 표시한다. */
export default function ExamCheerHeroBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 hidden overflow-hidden season:block"
    >
      <div className="exam-cheer-sky absolute inset-0" />
      <div className="absolute inset-y-0 right-0 w-[35%] opacity-30 sm:opacity-100">
        <div className="exam-cheer-rays absolute -right-10 top-0 h-full w-full" />
        <span className="absolute right-[18%] top-[14%] text-2xl text-amber-600 dark:text-amber-300">
          ✦
        </span>
        <span className="absolute bottom-[18%] left-[12%] text-lg text-orange-700 dark:text-orange-300">
          ✦
        </span>
      </div>
      <div className="exam-cheer-band absolute inset-x-0 bottom-0 h-1" />
    </div>
  );
}
